<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18mlIjM/tc-custom/9781442487994.jpg?1713839778389" alt="This image is the cover for the book Misty of Chincoteague"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Misty of Chincoteague
      </h1>
      <p class="bookDescription body article font2">
        <b>The timeless classic and beloved story of a wild horse’s gentle filly—winner of a Newbery Honor!</b><br/><br/>On the island of Chincoteague, off the coasts of Virginia and Maryland, lives a centuries-old band of wild ponies. Among them is the most mysterious of all, Phantom, a rarely-seen mare that eludes all efforts to capture her—that is, until a young boy and girl lay eyes on her and determine that they can’t live without her.<br/><br/>The frenzied roundup that follows on the next Pony Penning Day does indeed bring Phantom into their lives, in a way they never would have suspected. Phantom would forever be a creature of the wild. But her gentle, loyal filly Misty is another story altogether . . . <br/><br/><b>“A thrilling and long-to-be-remembered tale.” —<i>San Francisco Chronicle</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marguerite Henry
      </h2>
      
      <p class="authorDescription body article">Marguerite Henry (1902&ndash;1997) was the beloved author of such classic horse stories as&#160;<I>King of the Wind</I>,&#160;<I>Misty of Chincoteague</I>,&#160;and&#160;<I>Stormy, Misty&rsquo;s Foal</I>, and her work has won several Newbery Awards and Honors.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4e9de98